import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AuthService } from "src/app/providers/auth.service";
import { SessionService } from "src/app/providers/session.service";

@Component({
  selector: "app-logout-page",
  templateUrl: "./logout-page.component.html",
  styleUrls: ["./logout-page.component.scss"],
})
export class LogoutPageComponent implements OnInit {
  constructor(private authService: AuthService, private sessionService: SessionService, private router: Router) {}

  ngOnInit(): void {
    setTimeout(() => {
      this.sessionService.skip2FA = false;
      const logoutAns = this.sessionService.idToken !== null;
      const lougoutEhealth = this.authService.logout();
      if (!logoutAns && !lougoutEhealth) {
        this.router.navigate(["/login"]);
      }
    }, 0); // we need this timeOut to be sure that every javascript changes are done before disconnecting
  }
}
